import React, { useState } from "react";
import useStyles from "./stylesComponents";
import { Button, Select, Text } from "@mantine/core";
import { IconFile, IconFolder } from "@tabler/icons-react";
import { HiMenu } from "react-icons/hi";
import { MdGridView } from "react-icons/md";
import { FaChevronDown } from "react-icons/fa6";

function RowGridRadio({ onChange }) {
  const [selected, setSelected] = useState("grid");
  const { classes } = useStyles();

  const change = (val) => {
    onChange?.(val);
    setSelected(val);
  };
  return (
    <div className={classes.RowGridRadioParent}>
      <div
        className={
          selected === "row" ? classes.radioItemSelected : classes.radioItem
        }
        onClick={() => change("row")}
      >
        <HiMenu />
        <Text>List</Text>
      </div>
      <div
        onClick={() => change("grid")}
        className={
          selected === "grid" ? classes.radioItemSelected : classes.radioItem
        }
      >
        <MdGridView />
        <Text>Grid</Text>
      </div>
    </div>
  );
}

function FileFolderRadio({ onChange }) {
  const [selected, setSelected] = useState("folder");
  const { classes } = useStyles();

  const change = (val) => {
    onChange?.(val);
    setSelected(val);
  };
  return (
    <Select
      aria-label="Select File or Folder"
      value={selected}
      variant="unstyled"
      w={100}
      onChange={(val) => change(val)}
      className={classes.select}
      data={[
        { value: "file", label: "Files" },
        { value: "folder", label: "Folders" },
      ]}
      rightSection={<FaChevronDown />}
    />
  );
}

export { RowGridRadio, FileFolderRadio };
